import * as Yup from "yup";
import LookupType from "./LookupType";

export const CommonForemanWorkOrderDriversTimesSchema = Yup.object().shape({
    id: Yup.number().required(),
    job_detail_id: Yup.number().required(),
    driver_name: Yup.string().nullable(),
    driver_in: Yup.string().nullable(),
    on_job: Yup.string().nullable(),
    break_start: Yup.string().nullable(),
    break_end: Yup.string().nullable(),
    leave_job: Yup.string().nullable(),
    driver_out: Yup.string().nullable(),
    mmg_distance: Yup.string().nullable(),
    manchaca_distance: Yup.string().nullable(),
    is_drivers_times_section_complete: Yup.boolean()
})

export const CommonForemanWorkOrderCrewMembersSchema = Yup.object().shape({
    id: Yup.number().required(),
    job_detail_id: Yup.number().required(),
    workers: Yup.array().of(LookupType).nullable(),
    workers_other_1: Yup.string().nullable(),
    workers_other_2: Yup.string().nullable(),
    workers_other_3: Yup.string().nullable(),
    is_crew_section_complete: Yup.boolean()
})

export const CommonForemanWorkOrderForemanNotesSchema = Yup.object().shape({
    id: Yup.number().required(),
    job_detail_id: Yup.number().required(),
    foreman_notes: Yup.string().nullable(),
    is_foreman_notes_section_complete: Yup.boolean()
})